import MultiSelectDropdown from '../../Controls/multiselectdropdown';
import '../../../assets/Styles/DispatchCSS/DispatchCSS.css';
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {Col, Container, Modal, Row, Button, Spinner }from 'react-bootstrap';
import ZoneDropdown from './ZoneDropDown';
import APICom from '../../../utils/helpers/APICom';
import AlertBox from '../../common/alert';



function CabInOutForm(props) {
    const { loginData } = useSelector((store) => store.login);
    const parts = props.GridRowData[0].VEHNo.split("-");
    var vehNo = parts[0];
    const [zones, setZones] = useState([])
    const [selectedzone, setSelectedZone] = useState("");
    const [selectedzoneId, setSelectedZoneId] = useState(-1);
    const [AffiliateName, setAffiliateName] = useState('');
    const [zoneRank, setZoneRank] = useState(-1);
    const [standRank, setStandRank] = useState(-1);
    const [isChecked, setIsChecked] = useState(false);
    const [initialZoneId, setInitialZoneId] = useState(-1)
    const [rankList, setRankList] = useState([{}]);
    const [currRank, setCurrRank] = useState(-1);
    const [title, setTitle] = useState("-1");
    const [body, setBody] = useState("-1");
    const [showAlert, setShowAlert] = useState(false);
    const [selectedValue, setSelectedValue] = useState('default');

    useEffect(()=> {
        
        if(props.GridRowData !== undefined){
            setSelectedZone(props.GridRowData[0].PZONE);
            GetZones();
            GetRank();
         
        }
    }, []);
    
    const GetZones = async(e) => {
        try {
            let affId = props.GridRowData[0].iSRATSPID;
            var response = await APICom.fetchData("", "DispatchActions/GetAllZone?AffId=" +affId, "get", { "Content-Type": "application/json" }, null, null);

            if (response.data.length >0)
            {
                setZones(response.data);
                // setAffName(response.data[0]["vCompany"])
                setAffiliateName(response.data[0]["vCompany"]);
                const zone1 = response.data
                // Find the selected zone object based on the ID
                const sZone = zone1.find((zone) => zone.vZoneName === props.GridRowData[0].PZONE);
                if(sZone){
                    setSelectedZoneId(sZone.iZoneID)
                    setInitialZoneId(sZone.iZoneID)
                }
                // Call the parent's callback function with the selected zone name
                // onZoneChange(newZoneID, selectedZone ? selectedZone.vZoneName : '')
            }
            
        }
        catch
        {
            console.log('ERROR');
        }
    }
    const GetRank = async(e) => {
        try {
            let vId = props.GridRowData[0].iAssignedVehicleId 
            if (props.GridRowData[0].VEHNo.includes("-R"))
            {
                vId = props.GridRowData[0].iSpecialVehicleId;
            }
            
            var response = await APICom.fetchData("", "DispatchActions/GetVehicleStandZoneRank?vehicleId=" + parseInt(vId), "get", { "Content-Type": "application/json" }, null, null);

            setRankList(response.data);
            const dataObj = response.data
            if (dataObj.length >0)
            {
                setRankList(dataObj);
                const matchedObject = dataObj.find((obj) => obj.vzone === selectedzone);
                if(matchedObject)
                {
                    setZoneRank(matchedObject.iZoneRank);
                    setStandRank(matchedObject.iStandRank);
                }
            }
            
        }
        catch
        {
            console.log('ERROR');
        }
    }
    const handleZoneChange = (zoneId, newZone) => {
        setSelectedZoneId(zoneId);
        setSelectedZone(newZone);
        if (rankList.length > 0)
        {
            const matchedObject = rankList.find((obj) => obj.vzone === newZone);
            if(matchedObject)
            {
                setZoneRank(matchedObject.iZoneRank);
                setStandRank(matchedObject.iStandRank);
            }
        }
      };
    
   
    const handleOk = () => {
        if(zoneRank < 1)
        {
            insertFavor();
            if(initialZoneId == selectedzoneId)
            {
                
                insertVehicletoZone();
            }
            else
            {
                callDRZ()
            }
        }
        else{
            setTitle('Alert!');
            setBody("Vehicle already bookin!");
            setShowAlert(true);
        }
        //props.setShowInOut(false);
    };
    const callDRZ = async(e) => {
        try {
            let vId = props.GridRowData[0].iAssignedVehicleId 
            if (props.GridRowData[0].VEHNo.includes("-R"))
            {
                vId = props.GridRowData[0].iSpecialVehicleId;
            }
            
            var response = await APICom.fetchData("", "DispatchActions/GetVehicleOfDRZ?vehicleId=" + parseInt(vId) + "&iVZoneID=" + selectedzoneId, "get", { "Content-Type": "application/json" }, null, null);
            if (response.data.length >0)
            {
                setTitle('Success!!');
                setBody("Vehicle-BookIn Successfully!");
                setShowAlert(true);
            }
            else{
                setTitle('Failure!!');
                setBody("Vehicle-BookIn Failed!");
                setShowAlert(true);
            }
        }
        catch
        {
            console.log('ERROR');
        }
    }
    const insertFavor = async(e) => {
        try {
            let iAssignedVehicleId = props.GridRowData[0].iAssignedVehicleId;
            let AssignedDriverId = props.GridRowData[0].AssignedDriverId;
            let ServiceID = props.GridRowData[0].ServiceID;
            
            if (props.GridRowData[0].VEHNo.includes("-R"))
            {
                AssignedDriverId =  parseInt(props.GridRowData[0].iSpecialDriverId);
                iAssignedVehicleId = parseInt(props.GridRowData[0].iSpecialVehicleId);
            }
            var Param = {
                "iDriverID": parseInt(AssignedDriverId),
                "iVehicleID": parseInt(iAssignedVehicleId),
                "iServiceID": parseInt(ServiceID),
                "vReason": "",
                "iCreatedByUID": parseInt(loginData.iUserID)
              }

            await APICom.fetchData("", "DispatchActions/insertDriverFavor", "post", { "Content-Type": "application/json" }, Param, null);
        }
        catch
        {
            setTitle('Failure!');
            setBody("Error on inserting Favor!");
            setShowAlert(true);
        }
    }
    const insertVehicletoZone = async(e) => {
        try {
            let iAssignedVehicleId = props.GridRowData[0].iAssignedVehicleId;
            if (props.GridRowData[0].VEHNo.includes("-R"))
            {
                iAssignedVehicleId = props.GridRowData[0].iSpecialVehicleId;
            }
            let zoneID = selectedzoneId
            var Param = {
                "iVehicleID": parseInt(iAssignedVehicleId),
                "forceBookIn": false,
                "iVZoneID": parseInt(zoneID),
                "iPriorty": parseInt('0'),
                "bisMDT": false,
                "isBookIn": selectedValue === "IN",
                "bBookedInByDevice": false,
                "bIsInStand": selectedValue === "Bookin In Stand",
                "vReason": "Book_In_By_Dispatcher_Manually",
                "iUserID": parseInt(loginData.iUserID),
              }

            let response = await APICom.fetchData("", "DispatchActions/insertVehicleInZone", "post", { "Content-Type": "application/json" }, Param, null);
            if (response.data.length > 0)
            {
                setTitle('Success!!');
                setBody("Vehicle Successfully Book_In_By_Dispatcher_Manually!");
                setShowAlert(true);
            }
            else
            {
                setTitle('Failure!');
                setBody("Vehicle Book_In_By_Dispatcher_Manually Failed!");
                setShowAlert(true);
            }
        }
        catch
        {
            console.log('ERROR');
        }
    }
    const handleCheckboxChange = (e) => {
        // Use e.target.checked to get the current state of the checkbox
        setIsChecked(e.target.checked);
    };
    const handleCancel = () => {
        props.setShowInOut(false);
    };
    const handleCloseInOutDialog = () => {
        if(props.showInOut)
        {
            props.setShowInOut(false);
        }
    }
  return (
    <>
        {props.showInOut ? 
        <Modal centered show={props.showInOut} onHide={handleCloseInOutDialog} animation={true} backdrop="static" keyboard={true} size="lg" 
            aria-labelledby="contained-modal-title-vcenter">
            <Modal.Header className='activate_dialog_header_bgcolor' closeButton >
                <Modal.Title id="contained-modal-title-vcenter" className='activate_dialog_title_color user-select-none'>
                    Cab In/Out Form
                </Modal.Title>
            </Modal.Header>
        
            <Modal.Body className="grid-example">
                    
                <Row className="tripaction_btn_seperator"></Row>
                <Row>
                    <Col xs={4}>
                        <input type="checkbox" id="chkZoneInOut" className="chkZoneInOut" style={{ display: 'none' }} /><label htmlFor="cbxZone">In/Out Zone:</label>
                    </Col>
                    <Col xs={8}>
                            <span>Affiliate Name: {AffiliateName}</span> 
                    </Col>
                </Row>
                <Row>
                    <Col xs={4}>
                        <input type="radio" id="rdBtnIn" className="rdBtnIn" name="inOutRadio" value="IN" checked={selectedValue === "IN"} onChange={()=>setSelectedValue("IN")}/>
                        <label htmlFor="rdBtnIn" className='mx-1'>IN</label>
                    </Col>
                    <Col xs={8}>
                        <input type="radio" id="rdBtnOut" className="rdBtnOut" value="OUT" checked={selectedValue === "OUT"} onChange={()=>setSelectedValue("OUT")}/>
                        <label htmlFor="rdBtnOut" className='mx-1'>OUT</label>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} md={4}>
                        <label htmlFor="cbxVehNoDrop" className='user-select-none'>Select Vehicle #:</label>
                    </Col>
                    <Col xs={6} md={3}>          
                            <select id="cbxVehNoDrop" className="form-select form-control" disabled>
                                <option value="option1">{vehNo}</option>
                            </select>    
                    </Col>
                    <Col xs={6} md={4} className='mt-1'>
                        <span className='user-select-none'>Stand Rank: {standRank}</span> 
                    </Col>
                    
                </Row>

                <Row>
                    <Col xs={6} md={4}>
                        Select Zone/Stand :
                    </Col>
                    <Col xs={6} md={3}>
                    {selectedzone ? <ZoneDropdown zones={zones} selectedzone={selectedzone} onZoneChange={handleZoneChange}/>: ""}        
                    </Col>
                    <Col xs={6} md={4} className='mt-1'>
                        <span className='user-select-none'>Zone Rank: {zoneRank}</span> 
                    </Col>
                </Row>
                <Row> 
                    <Col xs={6} md={6}>
                        <input type="checkbox" id="chkInStand" className="chkInStand" value="Bookin In Stand" checked={selectedValue === "Bookin In Stand"} onChange={()=>setSelectedValue("Bookin In Stand")}/>&nbsp;Bookin In Stand
                    </Col>
                </Row>
            
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={handleOk}>
                    OK
                </Button>
                <Button variant="secondary" onClick={handleCancel}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal> :""}
        {showAlert ? <AlertBox showAlert={showAlert} setShowAlert={setShowAlert} title={title} body={body} />: ""}
        
    </>
  );
}

export default CabInOutForm;